import $ from 'jquery'

// Match content hight with the screen height;
let screenFiller = () => {
	let windowHeight = $(window).height()
	let bodyHeight = $('body').height()
	if (windowHeight > bodyHeight) {
		let entryHeight = $('.entry-content').outerHeight()
		$('.entry-content').css('min-height', entryHeight + windowHeight - bodyHeight)
	}
}

//initialise
$(document).ready(function() {
	screenFiller()
})

//export
export default screenFiller
